// src/systems/timeSystem.ts — Ciclo día/noche básico (Fase 2)
import { TIME_CONFIG } from '../data/gameConfig.js';

export type Phase = typeof TIME_CONFIG.phases[number]; // amanecer|dia|atardecer|noche

export class TimeSystem {
  tick: number = 0.25; // 0..1 (0 amanecer, 0.25 dia, 0.5 atardecer, 0.75 noche)
  phase: Phase = 'dia';
  private acc = 0;

  constructor(initialTick=0.25) { this.tick=initialTick; this.updatePhase(); }

  update(dt: number): void {
    this.tick = (this.tick + dt / TIME_CONFIG.dayLengthSeconds) % 1;
    this.updatePhase();
  }

  private updatePhase(): void {
    if (this.tick < 0.25) this.phase='amanecer';
    else if (this.tick < 0.5) this.phase='dia';
    else if (this.tick < 0.75) this.phase='atardecer';
    else this.phase='noche';
  }

  // Para shaders/overlays: intensidad y color
  getOverlay(): { alpha:number; color:string } {
    switch(this.phase){
      case 'amanecer': return { alpha: 0.08, color: 'rgba(255,180,120,1)' };
      case 'dia': return { alpha: 0, color: 'transparent' };
      case 'atardecer': return { alpha: 0.14, color: 'rgba(255,120,80,1)' };
      case 'noche': return { alpha: 0.32, color: 'rgba(10,15,40,1)' };
    }
  }

  getLabel(): string {
    const h = Math.floor(this.tick*24);
    const m = Math.floor((this.tick*24 - h)*60);
    return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')} · ${this.phase}`;
  }
}
